// Keep Notyf's own dismissal timers and stack behavior. Only reuse an active
// success with the exact same message; errors and warnings always use open().
export function reuseSuccessConfirmations(notyf) {
  const open = notyf.open.bind(notyf);
  const flashes = new WeakMap();

  notyf.open = (options) => {
    if (options.type === 'success' && typeof options.message === 'string') {
      // Notyf removes entries from its rendered list as soon as dismissal starts.
      const existing = notyf.view.notifications.find(
        ({ notification }) =>
          notification.options.type === 'success' &&
          notification.options.message === options.message &&
          notyf.notifications.indexOf(notification) !== -1,
      );
      if (existing) {
        const node = existing.node;
        flashes.get(node)?.cancel();
        if (typeof node.animate === 'function') {
          const reducedMotion = globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
          flashes.set(
            node,
            node.animate(
              [
                { filter: 'brightness(1)' },
                { filter: 'brightness(1.35)' },
                { filter: 'brightness(1)' },
              ],
              { duration: reducedMotion ? 120 : 320, easing: 'ease-out' },
            ),
          );
        }
        return existing.notification;
      }
    }
    // Paint the card itself, not Notyf's animated ripple layer. The background
    // must remain readable after entry/duplicate animations finish or cancel.
    return open({ ...options, ripple: false });
  };

  return notyf;
}
